import Glide from '@glidejs/glide'
import IMask from 'imask';
import "@babel/polyfill";

require('lightgallery.js');

const reviewSlider = new Glide('#review-slider', {
	type: 'carousel',
	autoplay: 0,
	perView: 3,
	breakpoints: {
		768: {perView: 1}
	}
}).mount();

const partnersSlider = new Glide('#partners-slider', {
	type: 'carousel',
	autoplay: 0,
	perView: 5,
	breakpoints: {
		768: {perView: 1}
	}
}).mount();

if (window.innerWidth < 768){
	const accreditationsSlider = new Glide('.accreditations-slider', {
		type: 'slider',
		autoplay: 0,
		animationDuration: 200,
		perView: 5,
		breakpoints: {
			768: {perView: 1}
		}
	}).mount();
}

NodeList.prototype.forEach = Array.prototype.forEach;

document.querySelectorAll('input[type=tel]').forEach((item)=> {
	IMask(item, {
				mask: '+{7} (000) 000-00-00'
			});
});




Array.from(document.getElementsByClassName('lightGallery')).forEach(
		(item) => {lightGallery(item);}
);


function scrollIt(destination, duration = 200, easing = 'linear', callback) {

	const easings = {
		linear(t) {
			return t;
		},
		easeInQuad(t) {
			return t * t;
		},
		easeOutQuad(t) {
			return t * (2 - t);
		},
		easeInOutQuad(t) {
			return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
		},
		easeInCubic(t) {
			return t * t * t;
		},
		easeOutCubic(t) {
			return (--t) * t * t + 1;
		},
		easeInOutCubic(t) {
			return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
		},
		easeInQuart(t) {
			return t * t * t * t;
		},
		easeOutQuart(t) {
			return 1 - (--t) * t * t * t;
		},
		easeInOutQuart(t) {
			return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
		},
		easeInQuint(t) {
			return t * t * t * t * t;
		},
		easeOutQuint(t) {
			return 1 + (--t) * t * t * t * t;
		},
		easeInOutQuint(t) {
			return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
		}
	};

	const start = window.pageYOffset;
	const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

	const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
	const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
	const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
	const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

	if ('requestAnimationFrame' in window === false) {
		window.scroll(0, destinationOffsetToScroll);
		if (callback) {
			callback();
		}
		return;
	}

	function scroll() {
		const now = 'now' in window.performance ? performance.now() : new Date().getTime();
		const time = Math.min(1, ((now - startTime) / duration));
		const timeFunction = easings[easing](time);
		window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

		if (window.pageYOffset === destinationOffsetToScroll) {
			if (callback) {
				callback();
			}
			return;
		}

		requestAnimationFrame(scroll);
	}

	scroll();
}

// example markup  <a data-scrollTo="footer">
document.querySelectorAll('[data-scrollTo]').forEach((element) => {
  element.addEventListener('click',(event) => {
    const selector = event.target.getAttribute('data-scrollTo') != null ? event.target.getAttribute('data-scrollTo') : event.target.closest('[data-scrollTo]').getAttribute('data-scrollto');
    scrollIt(document.querySelector(selector))
  })
});


document.querySelectorAll('.cityMenuTrigger').forEach((element) => {
  element.addEventListener('click', (event) => {
    const cityMenuDOM =   document.querySelector('.city_menu');

    if (!cityMenuDOM.classList.contains('active')) {
      cityMenuDOM.classList.add('active');
    }

  });
});

document.querySelectorAll('.cityMenuCloseTrigger').forEach((element) => {
  element.addEventListener('click', (event) => {

    const cityMenuDOM =   document.querySelector('.city_menu');

    if (cityMenuDOM.classList.contains('active')) {
      cityMenuDOM.classList.remove('active');
    }
  });
})
